// extracted by mini-css-extract-plugin
export default {"root":"jlrxdD2fEofOvbttXiIV","timeOfDay":"AxE2i7e9GQ3bESr_kV1u"};